import { Box, Collapse, HStack, Text, Tooltip, VStack } from "@chakra-ui/react";
import React from "react";
import {
  ChevronDownIcon,
  ChevronRightIcon,
  InfoIcon,
} from "../../styles/icons";

interface CollapsibleSectionProps {
  title: string;
  subtitle?: string;
  titleTooltip?: string;
  isOptional?: boolean;
  isOpen: boolean;
  onToggle: () => void;
  rightAdornment?: React.ReactNode;
  bg?: string;
  borderless?: boolean;
  children: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  subtitle,
  titleTooltip,
  isOptional = false,
  isOpen,
  onToggle,
  rightAdornment,
  bg,
  borderless = false,
  children,
}) => {
  return (
    <Box
      border={borderless ? undefined : "1px solid"}
      borderColor={borderless ? undefined : "cherryBorder.100"}
      borderRadius="lg"
      p={4}
      pt={6}
      pb={6}
      mb={4}
      bg={bg}
    >
      <HStack
        width="100%"
        cursor="pointer"
        onClick={onToggle}
        role="button"
        aria-expanded={isOpen}
        spacing={2}
      >
        <HStack spacing={3} flex="1" alignItems="center">
          <VStack alignItems="flex-start" spacing={1}>
            <Text fontSize="xl" fontWeight="700">
              {title}
            </Text>
            {subtitle && (
              <Text fontSize="xs" color="gray.500" letterSpacing="wide">
                {subtitle}
              </Text>
            )}
          </VStack>
          {titleTooltip && (
            <Tooltip label={titleTooltip} placement="top" hasArrow>
              <Box
                as="span"
                display="inline-flex"
                alignItems="center"
                color="gray.500"
                onClick={(e) => e.stopPropagation()}
              >
                <InfoIcon boxSize={4} />
              </Box>
            </Tooltip>
          )}
          {isOptional && (
            <Box bg="cherryBackground.tag" borderRadius="full" px={3} py={1}>
              <Text fontSize="sm" color="gray.700">
                Optional
              </Text>
            </Box>
          )}
        </HStack>
        {rightAdornment}
        {isOpen ? (
          <ChevronDownIcon boxSize={5} />
        ) : (
          <ChevronRightIcon boxSize={5} />
        )}
      </HStack>
      <Collapse in={isOpen} animateOpacity>
        <Box mt={4}>{children}</Box>
      </Collapse>
    </Box>
  );
};
